module.exports = __webpack_public_path__ + "img/errorPayment.a760a988.png";